import CryptoJS from 'crypto-js';

const SECRET_KEY = process.env.REACT_APP_SECRET_KEY; // Secret key from environment variables
// const SECRET_KEY = 'Y2NEaWdpWFhYSW5kdXM5OQ=='; // Secret key from environment variables
const key = CryptoJS.enc.Base64.parse(SECRET_KEY);
// Encrypt data

export const encryptData = (data) => {
    // const stringifiedData = JSON.stringify(data);
    const encrypted = CryptoJS.AES.encrypt(data, key, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7, // PKCS7 is compatible with PKCS5
    });
    return encrypted.toString(); // Base64 string, just like Java
};

// Decrypt data
export const decryptData = (encryptedData) => {
    const bytes = CryptoJS.AES.decrypt(encryptedData, SECRET_KEY);
    const decryptedData = bytes.toString(CryptoJS.enc.Utf8);
    return JSON.parse(decryptedData);
};